import { render, staticRenderFns } from "./add-edit-product.vue?vue&type=template&id=6551ff9d&scoped=true&"
import script from "./add-edit-product.vue?vue&type=script&lang=js&"
export * from "./add-edit-product.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-product.vue?vue&type=style&index=0&id=6551ff9d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6551ff9d",
  null
  
)

export default component.exports